import {BaseModel} from "@shared/models/base.model";
import {CompanyIndirectShareholderType, OfficerDocumentStatusEnum} from "@generated/graphql";
import {Officer} from "@modules/officer/models/officer.model";
import {Corporate} from "@modules/company/models/corporate.model";
import {corporateFactory} from "@modules/company/factories/corporate.factory";
import {officerFactory} from "@modules/officer/factories/officer.factory";
import {startCase} from "lodash-es";
import {AppStatusType} from "@shared/component/common/status/status.component";

export class CompanyIndirectShareholder extends BaseModel implements CompanyIndirectShareholderType {
  id: string;
  officer: Officer;
  company: Corporate;
  companyId: string;
  companyType: string;
  percentageOfShares: number;
  isUBO: boolean
  documentsStatus: OfficerDocumentStatusEnum
  canCreateShareholder: boolean
  remainingPercentageOfShares: number
  remainingPercentageOfSharesForUpdating: number
  canUploadDocument: boolean
  canDeleteDocument: boolean
  canDelete: boolean
  canUpdate: boolean
  shareholders: CompanyIndirectShareholder[]
  canViewShareholders: boolean
  isRequiredKyc: boolean
  layer: number
  allocatedCapitalTotal: number
  isWaitingForApprovalDeletion: boolean;
  _model: string;
  __typename: 'CompanyIndirectShareholderType';

  constructor(state: CompanyIndirectShareholderType) {
    super(state);

    this.officer = officerFactory.tryCreating(state.officer)

    this.company = corporateFactory.tryCreating(state.company)

    // Nested shareholders are hydrated from `shareholdersForOrganizationChart`.
    this.shareholders = []
  }

  get title (): string {
    return 'Shareholder'
  }

  get renderOfficerRole(): string {
    return this.title
  }

  get isNominee(): boolean {
    return false;
  }

  get remainingOfShares(): number {
    return this.remainingPercentageOfShares
  }

  get corporateShareholders(): CompanyIndirectShareholder[] {
    return this.shareholders.filter(item => item.officer.officerProfile.__typename === 'OfficerIndirectCompanyType')
  }

  get individualShareholders(): CompanyIndirectShareholder[] {
    return this.shareholders.filter(item => item.officer.officerProfile.__typename === 'OfficerIndirectPersonType')
  }

  get ownership(): number {
    return this.percentageOfShares;
  }

  get name(): string {
    return this.officer?.name;
  }

  get icon(): string {
    switch (this.officer.officerProfile.__typename) {
      case "OfficerIndirectCompanyType":
        return 'apartment';
      case "OfficerIndirectPersonType":
        return this.isUBO ? 'person-UBO' : 'person'
      default:
        return '';
    }
  }

  get documentStatusLabel(): string {
    return startCase(this.documentsStatus.toLowerCase());
  }

  get documentsStatusStyle(): AppStatusType {
    switch (this.documentsStatus) {
      case OfficerDocumentStatusEnum.AwaitingReview: {
        return 'warn';
      }
      case OfficerDocumentStatusEnum.Verified: {
        return 'success';
      }
      case OfficerDocumentStatusEnum.Rejected: {
        return 'error';
      }
      default:
        return 'default';
    }
  }

  getModelName(): string {
    return CompanyIndirectShareholder.name;
  }

  layerShareholder(): number {
    return this.layer
  }

  isIndirect() {
    // return false
    return true;
  }

   isIndirectKYC() {
    return false
  }
}
